import { CardMediaPill } from '@app/components/base/CardMediaPill';
import { SxProps, Theme } from '@mui/material';
import { ReactNode } from 'react';

/** Same styles as {@link CardMediaPill}; kept for fragment list call sites. */
export function FragmentMediaPill({
  children,
  gap = 0.25,
  sx,
}: {
  children: ReactNode;
  gap?: number;
  sx?: SxProps<Theme>;
}) {
  return (
    <CardMediaPill gap={gap} sx={sx}>
      {children}
    </CardMediaPill>
  );
}
